var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3984 22C17.9213 22 22.3984 17.5228 22.3984 12C22.3984 6.47715 17.9213 2 12.3984 2C6.87559 2 2.39844 6.47715 2.39844 12C2.39844 17.5228 6.87559 22 12.3984 22Z",
    fill: "#C00000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 16L12.4004 11",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4004,
    cy: 7,
    r: 1,
    transform: "rotate(-180 12.4004 7)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info-red.12b9459deb2a0ab3a29b7b4635fef5f5.svg";
export { ForwardRef as ReactComponent };